import { API_URL, STAGE } from "../constants";
import axios from "axios";

export function validatePassword(password: string) {
  return axios
    .post(`${API_URL}/${STAGE}/v2/cms/driver-registrations/password/validate`, {
      password,
    })
    .then((data) => data.data);
}
